import { render, staticRenderFns } from "./send-mail.vue?vue&type=template&id=770ba97a&"
import script from "./send-mail.vue?vue&type=script&lang=js&"
export * from "./send-mail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports